import './App.css';
import './V2HomeCard.css';

function V2HomeCard(props) {
    return (
        <div className='v2-home-card'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                    <i
                        className={props.icon}
                        style={{ fontSize: '1rem' }}
                    />
                </div>
                <div
                    className='mk2-subtitle'
                    style={{ marginLeft: '0.2em' }}
                >
                    {props.title}
                </div>
            </div>
            {props.children}
        </div>
    );
}

export default V2HomeCard;